<template>
  <div style="width: 100%;" v-loading.body="loading">
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.5em;">
          VENDOR REPORTING
        </el-row>
      </el-col>
      <el-col class="small">
          <a @click="showJson = ! showJson">.&nbsp;</a>
      </el-col>
      <el-col>
        <el-row type="flex" align="middle" justify="end">
          <el-button plain @click="generateReport" :disabled="disableReportRun">
            Run report
          </el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
          Report Options
        </el-row>
      </el-col>
    </el-row>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Summary/Detail
      </el-col>
      <el-col :span="4">
        <el-radio-group v-model="reportOptions.type" @change="updateReportType">
          <el-radio-button label="summary">Summary</el-radio-button>
          <el-radio-button label="detail_new">Detail</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Sort Type<sup>*</sup>
      </el-col>
      <el-col :span="8">
        <el-radio-group v-model="reportOptions.sort" @change="updateReportType">
          <el-radio-button label="vendorcode">By Vendor Code</el-radio-button>
          <el-radio-button label="vendorname">By Vendor Name</el-radio-button>
          <!-- <el-radio-button label="vendor">By Vendor</el-radio-button> -->
        </el-radio-group>
      </el-col>
    </el-row>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Periods/Dates
      </el-col>
      <el-col :span="21">
        <el-radio-group v-model="reportOptions.dates" @change="updateReportDates">
          <el-radio-button label="datesAll">All</el-radio-button>
          <el-radio-button label="datesPeriod">Period</el-radio-button>
          <el-radio-button label="datesPosted">Posting Date</el-radio-button>
          <el-radio-button label="datesEffective">Effective Date</el-radio-button>
          <el-radio-button label="datesDocument">Document (Invoice) Date</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>

    <div v-if="reportOptions.dates==='datesPeriod'" class="m-top-20">
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3"></el-col>
        <el-col :span="4">Starting Period</el-col>
        <el-col :span="3"></el-col>
        <el-col :span="4">Ending Period</el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3"></el-col>
        <el-col :span="4">
          <el-select v-model="selectedCodes.period_start" :multiple="false" placeholder="First Period">
            <el-option
              v-for="opt in allCodes.periods"
              :key="opt.id"
              :label="opt.id + ' - ' + opt.start"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3"></el-col>
        <el-col :span="4">
          <el-select v-model="selectedCodes.period_end" :multiple="false" placeholder="Last Period">
            <el-option
              v-for="opt in allCodes.periods"
              :key="opt.id"
              :label="opt.id + ' - ' + opt.start"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>

    <div v-if="reportOptions.dates==='datesPosted'" class="m-top-20">
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3" />
        <el-col :span="4">Posting Date Start</el-col>
        <el-col :span="3" />
        <el-col :span="4">Posting Date End</el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3" />
        <el-col :span="4">
          <DateField v-model="selectedCodes.time_posted_start" />
          <!-- <el-input v-model="selectedCodes.time_posted_start" placeholder="2001-01-01"/>-->
        </el-col>
        <el-col :span="3" />
        <el-col :span="4">
          <DateField v-model="selectedCodes.time_posted_end" />
          <!-- <el-input v-model="selectedCodes.time_posted_end" placeholder="2099-12-31"/>-->
        </el-col>
      </el-row>
    </div>

    <div v-if="reportOptions.dates==='datesEffective'" class="m-top-20">
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3" />
        <el-col :span="4">Effective Date Start <sup>**</sup></el-col>
        <el-col :span="3" />
        <el-col :span="4">Effective Date End <sup>**</sup></el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3" />
        <el-col :span="4">
          <DateField v-model="selectedCodes.effective_date_start" />
          <!-- <el-input v-model="selectedCodes.effective_date_start" placeholder="2001-01-01"/>-->
        </el-col>
        <el-col :span="3" />
        <el-col :span="4">
          <DateField v-model="selectedCodes.effective_date_end" />
          <!-- <el-input v-model="selectedCodes.effective_date_end" placeholder="2099-12-31"/>-->
        </el-col>
      </el-row>
      <el-row v-if="reportOptions.dates==='datesEffective'" type="flex" align="middle" justify="start">
        <el-col :span="3" />
        <el-col :span="21"><p><sup>**</sup> Posting Date is used if Effective Date is not Set</p></el-col>
      </el-row>
    </div>

    <div v-if="reportOptions.dates==='datesDocument'" class="m-top-20">
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3" />
        <el-col :span="4">Document Date Start</el-col>
        <el-col :span="3" />
        <el-col :span="4">Document Date End</el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3" />
        <el-col :span="4">
          <DateField v-model="selectedCodes.doc_date_start" />
          <!-- <el-input v-model="selectedCodes.doc_date_start" placeholder="2001-01-01"/>-->
        </el-col>
        <el-col :span="3" />
        <el-col :span="4">
          <DateField v-model="selectedCodes.doc_date_end" />
          <!-- <el-input v-model="selectedCodes.doc_date_end" placeholder="2099-12-31"/>-->
        </el-col>
      </el-row>
    </div>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Company
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="selectedCodes.company_id"
          :multiple="false" placeholder="All">
          <el-option
            v-for="opt in allCodes.companies"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" class="right">
        Production
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="selectedCodes.production_id"
          :multiple="false" placeholder="All">
          <el-option
            v-for="opt in allCodes.productions"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row type="flex" align="middle" justify="start" class="selectRow">
      <el-col :span="3" class="right">
        Series
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="selectedCodes.series_id"
          :multiple="true" placeholder="All">
          <el-option
            v-for="opt in allCodes.series"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" class="right">
        Location
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="selectedCodes.location_id"
          :multiple="true" placeholder="All">
          <el-option
            v-for="opt in allCodes.locations"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="selectRow">
      <el-col :span="3" class="right">
        Set
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="selectedCodes.set_id"
          :multiple="true" placeholder="All">
          <el-option
            v-for="opt in allCodes.sets"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" class="right">
        Free Field
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="selectedCodes.free_field_1_id"
          :multiple="true" placeholder="All">
          <el-option
            v-for="opt in allCodes.freefield1"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row v-if="(allCodes.currencies||[]).length > 1" type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Currency
      </el-col>
      <el-col :span="4">
        <el-select v-model="selectedCodes.currency_id" placeholder="All">
          <el-option
            v-for="opt in currencies"
            :key="opt.id"
            :label="opt.code"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" class="right">
        Convert To
      </el-col>
      <el-col :span="4">
        <el-select v-model="reportOptions.report_currency_id">
          <el-option
            v-for="opt in currencies"
            :key="opt.id"
            :label="opt.code"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Include
      </el-col>
      <el-col :span="1">
        <el-checkbox v-model="transactionTypes.pos.include"></el-checkbox> POs
      </el-col>
      <el-col :span="1">
        <el-checkbox v-model="transactionTypes.aps.include"></el-checkbox> APs
      </el-col>
      <el-col :span="1">
        <el-checkbox v-model="transactionTypes.pcs.include"></el-checkbox> PCs
      </el-col>
      <el-col :span="1">
        <el-checkbox v-model="transactionTypes.jes.include"></el-checkbox> JEs
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Report Output
      </el-col>
      <el-col :span="4">
        <el-select v-model="reportOptions.format">
          <el-option
            v-for="opt in reportOutputFormats"
            :key="opt.value"
            :label="opt.label"
            :value="opt.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <div class="clear"></div>
    <el-row type="flex" align="middle" justify="end" class="section">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
          Vendor Selection
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="24" :offset="1">
        <el-radio-group v-model="reportOptions.vendorQuickPick" @change="updateVendors" :disabled="loading || disableReportRun">
          <el-radio-button label="custom">Custom</el-radio-button>
          <el-radio-button label="all">All</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row v-show="reportOptions.vendorQuickPick==='custom'" type="flex" align="top" justify="start" class="headerRow">
      <el-col :span="24" :offset="1">
        <el-transfer
          ref="vendorTransfer"
          v-model="selectedCodes.vendor_id"
          :data="vendors"
          :titles="[ 'Unselected Vendors', 'Selected Vendors' ]"
          :props="{ key: 'id', label: 'display_name' }"
          filterable
          filter-placeholder="Search Vendors"
        >
        </el-transfer>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="end" class="section">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
          Account Selection
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="24" :offset="1">
        <el-radio-group v-model="reportOptions.accountQuickPick" @change="updateAccounts" :disabled="loading || disableReportRun">
          <el-radio-button label="custom">Custom</el-radio-button>
          <el-radio-button label="range">Range</el-radio-button>
          <el-radio-button label="all">All</el-radio-button>
          <el-radio-button label="expenses">Expenses Only</el-radio-button>
          <el-radio-button label="balance">Balance Sheet Only</el-radio-button>
          <el-radio-button label="none">None</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <div v-if="reportOptions.accountQuickPick==='range'" class="m-top-20">
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3"></el-col>
        <el-col :span="4">From</el-col>
        <el-col :span="3"></el-col>
        <el-col :span="4">To</el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3"></el-col>
        <el-col :span="4">
          <el-select v-model="selectedCodes.account_id2" clearable :multiple="false" placeholder="First Account" :filterable="true" @change="checkCodeValidity">
            <el-option
              v-for="opt in allCodes.accounts"
              :key="opt.id"
              :label="opt.code + ' - ' + opt.name"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3"></el-col>
        <el-col :span="4">
          <el-select v-model="selectedCodes.account_id1" clearable :multiple="false" placeholder="Last Account" :filterable="true" @change="checkCodeValidity">
            <el-option
              v-for="opt in filteredOptions2"
              :key="opt.id"
              :label="opt.code + ' - ' + opt.name"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>

    <el-row v-show="reportOptions.accountQuickPick==='custom'" type="flex" align="top" justify="start" class="headerRow">
      <el-col :span="24" :offset="1">
        <el-transfer
          ref="accountTransfer"
          v-model="selectedCodes.account_id"
          :data="accounts"
          :titles="[ 'Unselected Accounts', 'Selected Accounts' ]"
          :props="{ key: 'id', label: 'display_name' }"
          filterable
          filter-placeholder="Search Accounts"
        >
        </el-transfer>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <p><sup>*</sup> Required</p>
      </el-col>
      <el-button plain @click="generateReport" :disabled="disableReportRun">
        Run report
      </el-button>
    </el-row>
    <el-row v-if="showJson">
      <el-col>
        <textarea id="output" style="width: 100%; height: 500px;" v-model="prettyJson"></textarea>
      </el-col>
    </el-row>
    <el-row v-if="showJson">
      <el-col :span="1">
        <el-button plain @click="generateCustomReport" :disabled="disableReportRun">
          Run Customized Report
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import { sortObjectByProperty } from '@/utils/helpers/ObjectSorting'
  import { capitalizeFirstLetter } from '@/utils/helpers/StringOperations'
  import { reportMixins } from '@/Mixins/Reports'
  import DateField from '@/components/InputComponents/DateField.vue'
  import { notify } from '@/utils/helpers/Notify'

  export default {
    name: 'VendorReport',
    components: { DateField },
    mixins: [ reportMixins ],
    data () {
      const { getJasperHost } = this.$store.getters
      return {
        reportOptions: {
          transactionStatuses: [ 'posted', 'closed' ],
          accountQuickPick: 'all',
          vendorQuickPick: 'all',
          type: 'summary',
          dates: 'datesAll',
          sort: 'vendorcode',
          status: 'all',
          format: 'pdf',
          currencyFactor: undefined,
          report_currency_id: 1
        },

        allCodes: {},    // Show codes, e.g. accounts, series, locations, sets, etc.
        vendors: undefined,
        selectedCodes: {
          period_start: undefined,
          period_end: undefined,
          time_posted_start: undefined,
          time_posted_end: undefined,
          effective_date_start: undefined,
          effective_date_end: undefined,
          doc_date_start: undefined,
          doc_date_end: undefined,
          account_id: [],
          account_id1: [],
          account_id2: [],
          vendor_id: [],
          series_id: [],
          location_id: [],
          set_id: [],
          free_field_1_id: [],
          free_field_2_id: [],
          company_id: undefined,
          production_id: undefined,
          source_code_id: [],
          currency_id: []
        },
        jasperSettings: {
          reportServer: `${getJasperHost}rest_v2/reports/Revolution/Phoenix/`,
          reportSubtitle: 'Sorted by Vendorcode',
          reportName: 'vendor_history_summary'
        },

        transactionTypes: {     // Types of transactions and whether we need them or not
          'aps': { name: 'AP', include: true },
          'pcs': { name: 'PC', include: false },
          'jes': { name: 'JE', include: false },
          'cks': { name: 'CK', include: false },
          'pos': { name: 'PO', include: false }
        },
        reportOutputFormats: [
          { value: 'pdf', label: 'PDF' },
          { value: 'csv', label: 'CSV' }
        ],
        sortedAccounts: [],     // Sorted data by accounts, transaction ID.  Needed for 90% of reports
        sortedVendors: [],     // Sorted data by accounts, transaction ID.  Needed for 90% of reports
        bankRelatedAccounts: [],     // Do not show bank related accounts
        disableReportRun: false, // Disable run report button if false
        reportJson: undefined,
        prettyJson: undefined,
        showJson: false,
        reportNotif: undefined,
        collapseExpenses: false,
        loading: false
      }
    },

    computed: {
      username () { return this.$store.getters.getUser.username },
      filteredOptions2 () {
        return this.allCodes.accounts.filter((option) => option.id !== this.selectedCodes.account_id)
      },
      includedTypes () {
        if (this.selectedCodes.source_code_id.length) this.transactionTypes.jes.include = true
        return Object.values(this.transactionTypes).filter(types => types.include === true).map(type => type.name)
      },
      accounts () {
        let accountsNew = []
        for (let i in this.allCodes.accounts) {
          if (this.allCodes.accounts[i].type.toLowerCase() === 'header') continue
          accountsNew[i] = this.allCodes.accounts[i]
          accountsNew[i]['display_name'] = this.allCodes.accounts[i]['code'] + ' - ' + this.allCodes.accounts[i]['name']
        }
        return accountsNew
      },
      currencies () {
        if (typeof this.allCodes.currencies !== 'undefined' && this.allCodes.currencies.length > 0) {
          return sortObjectByProperty(this.allCodes.currencies, 'id')
        } else {
          return []
        }
      }
    },

    watch: {
    },

    methods: {
      checkCodeValidity () {
        const fromValue = this.selectedCodes.account_id2 !== '' ? this.allCodes.accounts.filter((account) => account.id === this.selectedCodes.account_id2) : this.allCodes.accounts.filter((element, index) => index === 0)
        const toValue = this.selectedCodes.account_id1 !== '' ? this.allCodes.accounts.filter((account) => account.id === this.selectedCodes.account_id1) : this.allCodes.accounts.filter((element, index) => index === this.allCodes.accounts.length - 1)
        if (fromValue && toValue) {
          if (fromValue[0].code > toValue[0].code) {
            this.disableReportRun = true
            notify(this, 'error', 'The To Account cannot be before the From Account. Please update your selection.')
          } else {
            if (this.selectedCodes.account_id2 === [] || this.selectedCodes.account_id1 === []) {
              this.selectedCodes.account_id = this.allCodes.accounts.map((account) => account.id)
            } else {
              this.disableReportRun = false
              this.filteredAccounts = this.allCodes.accounts.filter((account) => account.code >= fromValue[0].code && account.code <= toValue[0].code)
              this.selectedCodes.account_id = this.filteredAccounts.map((account) => account.id)
            }
          }
        }
      },
      resetComponent () {
        this.reportJson = this.sortedAccounts = undefined
        this.clearStore()
      },
      clearStore () {
        // TODO
      },
      updateReportType (type) {
        this.jasperSettings.reportSubtitle = 'Sorted by ' + capitalizeFirstLetter(this.reportOptions.sort)
        this.jasperSettings.reportName = this.reportOptions.type === 'summary' ? 'vendor_history_summary' : 'vendor_history_detail'
      },
      updateReportDates (type) {
        this.selectedCodes.period_start = this.selectedCodes.period_end = this.selectedCodes.time_posted_start = this.selectedCodes.time_posted_end = this.selectedCodes.effective_date_start = this.selectedCodes.effective_date_end = undefined
      },
      updateVendors (type) {
        if (!type) return false
        switch (type) {
          case 'none':
            this.disableReportRun = false
            this.selectedCodes.vendor_id = []
            break
          case 'all':
            this.disableReportRun = false
            this.selectedCodes.vendor_id = this.vendors.map(vendor => vendor.id)
            break
          case 'custom':
            this.disableReportRun = false
            break
          default:
            return undefined
        }
        // The transfer table is one tick behind.  Force update now
        this.$forceUpdate()
        return true
      },
      updateAccounts (type) {
        if (!type) return false
        switch (type) {
          case 'none':
            this.disableReportRun = false
            this.selectedCodes.account_id = []
            break
          case 'all':
            this.disableReportRun = false
            this.selectedCodes.account_id = this.allCodes.accounts.map(acct => acct.id)
            break
          case 'expenses':
            this.disableReportRun = false
            this.selectedCodes.account_id = this.allCodes.accounts.filter(({type}) => type.toLowerCase().match('expense')).map(acct => acct.id)
            break
          case 'balance':
            this.disableReportRun = false
            this.selectedCodes.account_id = this.allCodes.accounts.filter(({type}) => {
              if (type.toLowerCase().match('asset') || type.toLowerCase().match('liability') || type.toLowerCase().match('income')) return true
            }).map(acct => acct.id)
            break
          case 'custom':
            this.disableReportRun = false
            break
          case 'range':
            this.disableReportRun = false
            break
          default:
            return undefined
        }
        // The transfer table is one tick behind.  Force update now
        this.$forceUpdate()
        return true
      },
      includeAps ({target}) {
        this.transactionTypes.aps.include = target.checked
      },
      includeJes ({target}) {
        this.transactionTypes.jes.include = target.checked
      },
      includePcs ({target}) {
        this.transactionTypes.pcs.include = target.checked
      },
      includeCks ({target}) {
        this.transactionTypes.cks.include = target.checked
      },
      includePos ({target}) {
        this.transactionTypes.pos.include = target.checked
      },
      selectReportFormat ({target}) {
        if (target.checked) {
          this.reportOptions.format = 'csv'
        } else {
          this.reportOptions.format = 'pdf'
        }
      },
      buildCsvData (sortedVendors) {
        let detailedColumns = { 'Company': 'company_name', 'Production': 'production_name', 'Transaction Type': 'trans_type', 'Transaction ID': 'trans_number', 'Transaction Description': 'transaction_description', 'Transaction Line Description': 'line_desc', 'Account': 'account', 'Account Description': 'account_name', 'Vendor Code': 'transaction_vendor', 'Vendor Name': 'vendor_name', 'Series': 'series', 'Location': 'location', 'Set': 'set', 'FF1': 'free_field_1', 'FF2': 'free_field_2', 'Tax Code': 'tax_code', 'Asset': 'asset', 'Document Number': 'doc_number', 'Document Date': 'doc_date', 'Posting Date': 'transaction_time_posted', 'Effective Date': 'transaction_effective_date', 'Period': 'period_id', 'PO Number': 'po_number', 'Check Number': 'payment_number', 'Bank Recon': 'recon', 'Check Amount': 'transaction_payment_amount', 'Doc Amount': 'amount' }
        let summaryColumns = { 'Vendor Number': 'vendor_number', 'Vendor Name': 'vendor_name', 'Payment Amount': 'vendor_payment_total', 'Doc Amount': 'vendor_total' }

        // TODO: Sipra Output
        let columnMap = (this.reportOptions.type === 'summary') ? summaryColumns : detailedColumns

        return new Promise((resolve, reject) => {
          let ledgerData = []

          for (const i in sortedVendors.current) {
            const currentVendor = this.vendors.find((ven) => ven.id === sortedVendors.current[i][0].vendor_id_line)
            const vendorDetails = sortedVendors.current[i].filter(({ account_id }) => !this.bankRelatedAccounts.includes(account_id))

            let vendor = {}
            vendor.vendor_number = currentVendor.code
            vendor.vendor_name = currentVendor.name
            vendor.vendor_total = this.sumRecursive(vendorDetails, 'amount')
            vendor.details = vendorDetails
            if (this.reportOptions.type === 'summary') {
              const uniqueTransactionIds = Array.from(new Set(vendorDetails.map(ven => ven.trans_number)))
              vendor.details = []
              uniqueTransactionIds.forEach(id => {
                // eslint-disable-next-line
                const lines = vendorDetails.filter(({ trans_number }) => trans_number === id)
                const header = lines[0] || {}
                let detail = {
                  trans_number: header.trans_number,
                  payment_number: header.payment_number,
                  transaction_payment_type: header.transaction_payment_type,
                  transaction_payment_amount: header.transaction_payment_amount || this.sumRecursive(lines, 'amount')
                }
                vendor.details.push(detail)
              })
              // Identify unique payments
              const paymentTotal = []
              const reusablePaymentNumbers = ['WIRE', 'EFT', 'MC']
              vendor.details.reduce((res, trans) => {
                const paymentId = trans.payment_number || trans.trans_number
                if (!res[paymentId] || (reusablePaymentNumbers.includes(trans.transaction_payment_type))) {
                  res[paymentId] = { payment_number: paymentId, transaction_payment_amount: trans.transaction_payment_amount }
                  paymentTotal.push(res[paymentId])
                }
                return res
              }, {})

              vendor.vendor_payment_total = this.sumRecursive(paymentTotal, 'transaction_payment_amount')
              vendor.details = undefined
              ledgerData.push(vendor)
            } else {
              vendor.details.map(row => ledgerData.push(row))
            }
          }

          this.disableReportRun = false
          let finalCsv = this.createCsv(ledgerData, columnMap)
          if (finalCsv) resolve(finalCsv)
          else reject('Could not build CSV.')
        })
      },

      buildVendorReport (sortedVendors) {
        return new Promise((resolve, reject) => {
          let json = {
            report: {
              report_title: 'Vendor History',
              report_subtitle: this.jasperSettings.reportSubtitle,
              report_name: this.jasperSettings.reportName,
              printed_by: this.username,
              date_run: this.today(),
              company: (this.selectedCodes.company_id) ? (this.allCodes.companies.find(({id}) => id === this.selectedCodes.company_id).name) : this.allCodes.companies[0].name,
              project: (this.selectedCodes.production_id) ? (this.allCodes.productions.find(({id}) => id === this.selectedCodes.production_id).name) : this.allCodes.productions[0].name,

              period: (this.selectedCodes.period_start ? (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_start).start) : this.selectedCodes.time_posted_start || 'Beginning') + ' - ' + (this.selectedCodes.period_end ? (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_end).end) : this.selectedCodes.time_posted_end || 'End'),
              currency: (this.reportOptions.report_currency_id) ? (this.allCodes.currencies.find(({id}) => id === this.reportOptions.report_currency_id).code) : this.currencies[0].code,
              date_start: (this.selectedCodes.period_start ? (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_start).start) : this.selectedCodes.time_posted_start || this.selectedCodes.effective_date_start || this.selectedCodes.doc_date_start || '0000/00/00'),
              date_end: (this.selectedCodes.period_end ? (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_end).end) : this.selectedCodes.time_posted_end || this.selectedCodes.effective_date_end || this.selectedCodes.doc_date_end || '9999/99/99'),
              grand_total: 0,
              grand_payment_total: 0,
              transactions: 'All',
              episodes: (this.selectedCodes.series_id && this.selectedCodes.series_id.length > 0) ? (this.allCodes.series.find(({id}) => this.selectedCodes.series_id.includes(id)).code) : 'All',
              locations: (this.selectedCodes.location_id && this.selectedCodes.location_id.length > 0) ? (this.allCodes.locations.find(({id}) => this.selectedCodes.location_id.includes(id)).code) : 'All',
              sets: (this.selectedCodes.set_id && this.selectedCodes.set_id.length > 0) ? (this.allCodes.sets.find(({id}) => this.selectedCodes.set_id.includes(id)).code) : 'All',
              free_fields: (this.selectedCodes.free_field_1_id && this.selectedCodes.free_field_1_id.length > 0) ? (this.allCodes.freefield1.find(({id}) => this.selectedCodes.free_field_1_id.includes(id)).code) : 'All',
              sourcecodes: (this.selectedCodes.source_code_id && this.selectedCodes.source_code_id.length > 0) ? (this.allCodes.sourcecodes.find(({id}) => this.selectedCodes.source_code_id.includes(id)).code) : 'All',
              accounts: capitalizeFirstLetter(this.reportOptions.accountQuickPick),
              data: []
            }
          }

          // Put finished data here
          let ledgerData = []
          for (const i in sortedVendors.current) {
            const currentVendor = this.vendors.find((ven) => ven.id === sortedVendors.current[i][0].vendor_id_line)
            const vendorDetails = sortedVendors.current[i].filter(({ account_id }) => !this.bankRelatedAccounts.includes(account_id))

            // Build unique transactions
            const uniqueTransactionIds = Array.from(new Set(vendorDetails.map(ven => ven.trans_number)))

            let vendor = {}
            vendor.vendor_number = currentVendor.code
            vendor.vendor_name = currentVendor.name
            vendor.vendor_total = this.sumRecursive(vendorDetails, 'amount')
            vendor.vendor_payment_total = 0

            // Legacy vendor report
            if (this.reportOptions.type === 'detail') {
              vendor.details = vendorDetails

            // New vendor report
            } else {
              vendor.details = []
              uniqueTransactionIds.forEach(id => {
                // eslint-disable-next-line
                const lines = vendorDetails.filter(({ trans_number }) => trans_number === id)
                const header = lines[0] || {}
                let detail = {
                  account: header.account || '',
                  doc_date: header.doc_date,
                  doc_number: header.doc_number,
                  transaction_description: header.transaction_description,
                  trans_number: header.trans_number,
                  trans_type: header.trans_type,
                  transaction_effective_date: header.transaction_effective_date,
                  transaction_period_id: header.transaction_period_id,
                  transaction_currency: header.transaction_currency,
                  transaction_bank: header.transaction_bank,
                  payment_number: header.payment_number,
                  transaction_payment_type: header.transaction_payment_type,
                  transaction_payment_date: header.transaction_payment_date,
                  transaction_payment_amount: header.transaction_payment_amount || this.sumRecursive(lines, 'amount'),
                  transaction_amount_decimal: this.sumRecursive(lines, 'amount'), // header.transaction_amount_decimal,
                  lines
                }
                vendor.details.push(detail)
              })

              // Identify unique payments
              const paymentTotal = []
              // The payment types in the reusablePaymentNumbers array can share the same
              // number of transaction; however, they should be considered as different
              // payments in order to calculate the total amount
              const reusablePaymentNumbers = ['WIRE', 'EFT', 'MC']
              vendor.details.reduce((res, trans) => {
                const paymentId = trans.payment_number || trans.trans_number
                if ((!res[paymentId]) || (reusablePaymentNumbers.includes(trans.transaction_payment_type))) {
                  res[paymentId] = { payment_number: paymentId, transaction_payment_amount: trans.transaction_payment_amount }
                  paymentTotal.push(res[paymentId])
                }
                return res
              }, {})
              vendor.vendor_payment_total = this.sumRecursive(paymentTotal, 'transaction_payment_amount')
            }

            json.report.grand_total += parseFloat(vendor.vendor_total)
            json.report.grand_payment_total += parseFloat(vendor.vendor_payment_total)

            ledgerData.push(vendor)
          }
          if (this.reportOptions.sort === 'vendorcode') ledgerData.sort((a, b) => a.vendor_number - b.vendor_number)
          else ledgerData.sort((a, b) => a.vendor_name.localeCompare(b.vendor_name))
          json.report.data = ledgerData
          resolve(json)
        })
      },
      generateReport () {
        this.loading = true
        this.disableReportRun = true

        if (this.reportOptions.format === 'csv') {
          this.getReportData('vendorreport')
            .then((resSorted) => {
              return resSorted.data
            })
            .then((results) => {
              return this.buildCsvData(results)
            })
            .then((resCsv) => {
              this.loading = false
              this.prettyJson = resCsv
              this.createNotification('Success', 'CSV is Ready. ', 'success', false, true, 'VendorReport')
              return true
            })
            .catch(error => {
              this.loading = false
              console.log(error)
            })
        } else {
          this.getReportData('vendorreport')
            .then((resSorted) => {
              return resSorted.data
            })
            .then((results) => {
              return this.buildVendorReport(results)
            })
            .then(json => {
              this.reportJson = json
              this.prettyJson = JSON.stringify(json, null, 2)
              return this.getJsonUrl(json)
            })
            .then(resJsonUrl => {
              // PDF version of the report
              let report = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.pdf?net.sf.jasperreports.json.source=' + resJsonUrl
              // HTML version of the report
              let preview = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.html?net.sf.jasperreports.json.source=' + resJsonUrl
              return this.getReportUrl(report)
            })
            .then(reportUrl => {
              this.loading = false
              this.createNotification('Success', 'Report is Ready. ', 'success', reportUrl)
            })
            .catch(error => {
              this.loading = false
              console.log(error)
            })
        }
      }
    },

    beforeCreate () {
    },

    created () {
      // Load data to be used for validation
      this.disableReportRun = true
      this.getCompanyData()
        .then(response => {
          this.allCodes = Object.assign({}, response.data)
          return this.allCodes.banks
        })
        .then(banks => {
          banks.map(bank => {
            this.bankRelatedAccounts.push(bank.default_account_cash_id)
            this.bankRelatedAccounts.push(bank.default_account_clearing_id)
            this.bankRelatedAccounts.push(bank.default_account_deposits_id)
            this.bankRelatedAccounts.push(bank.default_account_discount_id)
          })
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.disableReportRun = false
        })

      this.getVendorData()
        .then(response => {
          this.loading = false
          this.vendors = sortObjectByProperty(response.data, 'code')
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },

    mounted () {
    },

    beforeDestroy () {
      this.resetComponent()
    }
  }

</script>
<style scoped>
  .small { font-size: 8px; }
  .right { float: right; text-align: right; padding: 0px 5px; }
  .left { float: left; text-align: left; padding: 0px 5px; }
  .selectRow { padding: 0px 20px; }
  .section { padding: 40px 20px 0px;  }
  .headerRow { padding: 15px 20px 0px; }
  .m-top-20 { margin-top: 20px; }
  .m-right-20 { margin-right: 20px; }
</style>
<style>
  .el-select { display: block; }
  .el-transfer-panel { width:36%; max-width: 350px }
  .el-transfer-panel__body { min-height: 400px }
  .el-transfer-panel__list { min-height: 360px }
  /* border: 1px solid #d1dbe5; box-shadow: 0 2px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04); display: inline-block; width: 30%; position: relative; height: 500px; */
</style>



// WEBPACK FOOTER //
// src/components/Reports/VendorReportCustom.vue